import { VariableType } from 'json-to-graphql-query';
import { ProfileVariables, ProfileArgs } from './queryVariables/profile';
import { EntityResource } from './entity.resource';
/**
 * Resource profili
 *
 * @export
 * @class ProfileResource
 * @extends {EntityResource<Profile>}
 */
export class ProfileResource extends EntityResource {
    constructor() {
        super({ entityName: 'profile', addMutationName: 'accountRegister' });
        this.getVariables = { id: 'String!' };
        this.getFields = {
            id: true,
            firstName: true,
            lastName: true,
            pesel: true,
            birthDate: true,
            email: true,
            phoneNumber: true,
            companyName: true,
            companyPosition: true,
            type: true,
            gender: true,
            confirmReason: true,
            confirmReasonDescription: true,
            created: true,
            state: true,
            mainImage: true,
            user: {
                login: true,
                state: true
            },
            woj: true,
            pow: true,
            gmi: true,
            terc: true,
            city: true,
            simc: true,
            street: true,
            ulic: true,
            postalCode: true,
            homeNumber: true,
            localNumber: true,
            needsPasswordChange: true,
            userId: true
        };
        this.listFields = {
            id: true,
            firstName: true,
            lastName: true,
            email: true,
            userId: true,
            user: {
                login: true
            }
        };
        this.listVariables = { filters: 'ProfileFilters' };
        this.addVariables = { ...ProfileVariables, login: 'String!', termIds: '[Int!]' };
        this.addArgs = { ...ProfileArgs, login: new VariableType('login'), termIds: new VariableType('termIds') };
        this.updateVariables = { id: 'Int!', ...ProfileVariables };
        this.updateArgs = { id: new VariableType('id'), ...ProfileArgs };
    }
    /**
     * Pobiera podstawowe informacje o profilu
     *
     * @param {number} id
     * @returns {Promise<Profile>}
     * @memberof ProfileResource
     */
    simpleProfile(id) {
        const query = this.prepareOptions({
            query: {
                __variables: { id: 'Int!' },
                profile: {
                    __args: { id: new VariableType('id') },
                    id: true,
                    firstName: true,
                    lastName: true,
                    email: true,
                    type: true
                }
            }
        });
        return this.query({ query, variables: { id } }, 'profile');
    }
    /**
     * Wyszukanie imienia i nazwiska właściciela karty
     *
     * @param {string} cardNumber
     * @param {ProfileType} [type]
     * @returns
     * @memberof ProfileResource
     */
    profileSimpleByCardNumber(cardNumber, type) {
        const query = this.prepareOptions({
            query: {
                __variables: { cardNumber: 'String!', type: 'ProfileType' },
                profileSimpleByCardNumber: {
                    __args: { cardNumber: new VariableType('cardNumber'), type: new VariableType('type') },
                    firstName: true,
                    lastName: true
                }
            }
        });
        return this.query({ query, variables: { cardNumber, type } }, 'profileSimpleByCardNumber');
    }
    /**
     * Pobiera id profilu na podstawie emaila użytkownika
     *
     * @param {string} email
     * @param {ProfileType} [type]
     * @returns {Promise<number>}
     * @memberof ProfileResource
     */
    findByEmail(email, type) {
        return this.findByField('email', 'profileByEmail', email, type);
    }
    /**
     * Pobiera id profilu na podstawie numeru pesel użytkownika
     *
     * @param {string} pesel
     * @param {ProfileType} [type]
     * @returns {Promise<number>}
     * @memberof ProfileResource
     */
    findByPESEL(pesel, type) {
        return this.findByField('pesel', 'profileByPESEL', pesel, type);
    }
    /**
     * Pobiera id profilu na podstawie numeru telefonu użytkownika
     *
     * @param {string} phoneNumber
     * @param {ProfileType} [type]
     * @returns {Promise<number>}
     * @memberof ProfileResource
     */
    findByPhoneNumber(phoneNumber, type) {
        return this.findByField('phoneNumber', 'profileByPhoneNumber', phoneNumber, type);
    }
    /**
     * Pobiera id profilu na podstawie numeru telefonu użytkownika
     *
     * @param {string} cardNumber
     * @param {ProfileType} [type]
     * @returns {Promise<number>}
     * @memberof ProfileResource
     */
    findByCardNumber(cardNumber, type) {
        return this.findByField('cardNumber', 'profileByCardNumber', cardNumber, type);
    }
    /**
     * Pobiera id profilu na podstawie danego pola
     *
     * @param {string} field
     * @param {string} queryName
     * @param {*} value
     * @param {ProfileType} [type]
     * @returns {Promise<number>}
     * @memberof ProfileResource
     */
    findByField(field, queryName, value, type) {
        const query = this.prepareOptions({
            query: {
                __variables: { [field]: 'String!', type: 'ProfileType' },
                [queryName]: {
                    __args: {
                        [field]: new VariableType(field),
                        type: new VariableType('type')
                    }
                }
            }
        });
        return this.query({ query, variables: { [field]: value, type } }, queryName);
    }
    /**
     * Aktualizacja profilu
     *
     * @param {number} id
     * @param {Profile} profile
     * @returns {Promise<number>}
     * @memberof ProfileResource
     */
    update(id, profile) {
        return super.update(id, { profile: { ...profile, id: undefined } });
    }
}
export const profileResource = new ProfileResource();
//# sourceMappingURL=profile.resource.js.map